export class UserProfileDTO {
  code: string;
  description: string;
  id?: number;
  rankOrder?: number;
  enabled?: boolean;
}

export enum UserProfileCodes {
  ADMINISTRATOR = "ADMINISTRATOR",
  TENANT_ADMINISTRATOR = "TENANT_ADMINISTRATOR",
  ENTITY_ADMINISTRATOR = "ENTITY_ADMINISTRATOR",
  MULTIMEDIA_MANAGER = "MULTIMEDIA_MANAGER",
  FLEET_MANAGER = "FLEET_MANAGER",
}
